module.exports = __webpack_public_path__ + "img/fontello.de38b8a.svg";